import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Span, Tooltip } from "@ir/ui";
import "./DeductionUserDisplay.scss";

interface DeductionUserDisplayProps {
  style?: React.CSSProperties;
  name: string | null;
  placement?: "top" | "bottom" | "left" | "right";
}

const DeductionUserDisplay = ({ style, name, placement = "top" }: DeductionUserDisplayProps) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const span = spanRef.current;
    if (span) {
      setIsTruncated(span.scrollWidth > span.clientWidth);
    }
  }, [name]);

  const spanElement = useMemo(
    () => (
      <span ref={spanRef} className="analyst-approver-name-display-ellipsis text-grey-600" style={style}>
        {name}
      </span>
    ),
    [name, style]
  );

  const content = useMemo(() => {
    if (!name) {
      return <Span className="text-grey-400">Unassigned</Span>;
    }

    const wrappedContent = isTruncated ? (
      <Button noStyle className="analyst-approver-name-display truncated">
        {spanElement}
      </Button>
    ) : (
      spanElement
    );

    return isTruncated ? (
      <Tooltip content={name} placement={placement}>
        {wrappedContent}
      </Tooltip>
    ) : (
      wrappedContent
    );
  }, [name, isTruncated, spanElement, placement]);

  return content;
};

export default DeductionUserDisplay;
